// İSG uzmanı portalı — Ayarlar (Settings) TanStack Query anahtarları (api-contract
// §10, tenant-scoped). Liste anahtarları parametreleri içerir (sayfa/arama/şube
// filtresi değişince yeniden çeker); invalidasyon önek (prefix) ile yapılır:
// `['settings','branches']` tüm şube listesi sorgularını kapsar.
//
// Admin (§9) anahtarlarından (`adminKeys`) AYRIDIR — Ayarlar tek firmaya kapsanmış
// tenant yüzeyidir; cross-tenant admin anahtarlarıyla karışmaz.

import type { SettingsListParams } from '@isgportal/shared';

export const settingsKeys = {
  /** Çağıranın firması (tekil) — gate sondası ile PAYLAŞILIR (tek istek). */
  company: () => ['settings', 'company'] as const,
  branches: (params?: SettingsListParams) =>
    params ? (['settings', 'branches', params] as const) : (['settings', 'branches'] as const),
  /** Saha formundaki şube seçici için tüm şubeler (tek sayfa, ada göre sıralı). */
  branchOptions: () => ['settings', 'branch-options'] as const,
  sites: (params?: SettingsListParams & { branchUuid?: string }) =>
    params ? (['settings', 'sites', params] as const) : (['settings', 'sites'] as const),
} as const;
